import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiKey = environment.apiKey;
  private apiUrl = environment.apiUrl + '/mti/';

  constructor(private http: HttpClient) {}

  public get(url: string): Observable<any> {
    return this.http.get(this.apiUrl + url, {
      observe: 'response',
      headers: this.createHeaders(),
    });
  }

  public post(url: string, body: {}): Observable<any> {
    return this.http.post(this.apiUrl + url, body, {
      observe: 'response'
    });
  } 

  public put(url: string, body: {}): Observable<any> {
    return this.http.put(this.apiUrl + url, body, {
      observe: 'response'
    });
  }

  public delete(url: string): Observable<any> {
    return this.http.delete(this.apiUrl + url, {
      observe: 'response'
    });
  }

  private createHeaders(): HttpHeaders {
    const date = new Date();
    const signature = CryptoJS.HmacSHA256(date.toUTCString(),this.apiKey).toString();
    return new HttpHeaders({
      Authorization: `Bearer ${signature}`,
      'x-timestamp': date.toUTCString(),
    });
  }
}
